// extracted by mini-css-extract-plugin
export default {"Background":"BackgroundPopup_Background__S8MNu"};